import { DotLoader } from "react-spinners";

export default function SpinnerDot() {
  return (
    <div className="w-full flex flex-col items-center">
      <DotLoader color={"rgb(55, 205, 190)"} size="12rem" />
      <span className="block mt-10 text-2xl font-bold">Loading...</span>
    </div>
  );
}
